<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Global Search</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Global Search Content</b>
      <!-- <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Content Type"
            label-for="input-1"
          >
            <b-form-select
              v-model="item.type_name"
              name="content_type"
              v-validate="'required'"
              data-vv-as="Content Type"
              class="form-control"
            >
              <template v-slot:first>
                <option value disabled>-- Content Type--</option>
              </template>
              <option
                v-for="data in optionContentTypes"
                :key="data.id"
                :value="data.type_name"
              >
                {{ data.type_desc }}
              </option>
            </b-form-select>

            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("content_type") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title Bahasa"
            label-class="control-label"
            class="required"
            label-for="title-id"
          >
            <input
              v-model="item.title_id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Title Bahasa"
              id="title-id"
              class="form-control"
              placeholder="Title Bahasa"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Title English"
            label-class="control-label"
            class="required"
            label-for="title-en"
          >
            <input
              v-model="item.title_en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Title English"
              id="title-en"
              class="form-control"
              placeholder="Title English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Quick / Meta Description Bahasa"
            label-class="control-label"
            class="required"
            label-for="meta-desc-id"
          >
            <textarea
              id="meta-desc-id"
              type="text"
              class="form-control"
              v-validate="'required'"
              name="meta_desc_id"
              data-vv-as="Quick / Meta Description Bahasa"
              v-model="item.meta_desc_id"
              placeholder="Quick / Meta Description Bahasa"
              style="height: 70px"
            />
            <b-form-invalid-feedback id="input-meta_desc_id-feedback">{{
              veeErrors.first("meta_desc_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Quick / Meta Description English"
            label-class="control-label"
            class="required"
            label-for="meta-desc-en"
          >
            <textarea
              id="meta-desc-en"
              type="text"
              class="form-control"
              v-validate="'required'"
              name="meta_desc_en"
              data-vv-as="Quick / Meta Description English"
              v-model="item.meta_desc_en"
              placeholder="Quick / Meta Description English"
              style="height: 70px"
            />
            <b-form-invalid-feedback id="input-meta_desc_en-feedback">{{
              veeErrors.first("meta_desc_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Content Bahasa"
            label-class="control-label"
            class="required"
            label-for="content-id"
          >
            <textarea
              id="content-id"
              type="text"
              class="form-control"
              v-validate="'required'"
              name="content_id"
              data-vv-as="Content Bahasa"
              v-model="item.content_id"
              placeholder="Content Bahasa"
              style="height: 70px"
            />
            <b-form-invalid-feedback id="input-content_id-feedback">{{
              veeErrors.first("content_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Content English"
            label-class="control-label"
            class="required"
            label-for="content-en"
          >
            <textarea
              id="content-en"
              type="text"
              class="form-control"
              v-validate="'required'"
              name="content_en"
              data-vv-as="Content English"
              v-model="item.content_en"
              placeholder="Content English"
              style="height: 70px"
            />
            <b-form-invalid-feedback id="input-content_en-feedback">{{
              veeErrors.first("content_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL Bahasa"
            label-class="control-label"
            class="required"
            label-for="url-id"
          >
            <input
              v-model="item.url_id"
              v-validate="'required|url: {require_protocol: true }'"
              name="url_id"
              data-vv-as="URL Bahasa"
              id="url-id"
              class="form-control"
              placeholder="URL Bahasa"
            />
            <b-form-invalid-feedback id="input-url_id-feedback">{{
              veeErrors.first("url_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="URL English"
            label-class="control-label"
            class="required"
            label-for="url-en"
          >
            <input
              v-model="item.url_en"
              v-validate="'required|url: {require_protocol: true }'"
              name="url_en"
              data-vv-as="URL English"
              id="url-en"
              class="form-control"
              placeholder="URL English"
            />
            <b-form-invalid-feedback id="input-url_en-feedback">{{
              veeErrors.first("url_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'GlobalSearch' }">
            <b-button :disabled="loading" class="col-2 mr-3" variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
          <b-button
            variant="primary"
            :disabled="loading || !isValidAllField"
            @click="saveGlobalSearch()"
            class="col-2"
            size="lg"
          >
            Create
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      item: {
        title_id: "",
        title_en: "",
        meta_desc_id: "",
        meta_desc_en: "",
        content_id: "",
        content_en: "",
        url_id: "",
        url_en: "",
        type_name: "web_page",
      },
      // optionContentTypes: [],
      loading: false,
    }
  },
  beforeMount() {
    // this.$store
    //   .dispatch("GlobalSearchModule/getContentTypes")
    //   .then((response) => {
    //     this.optionContentTypes = response.data.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  computed: {
    isValidAllField() {
      if (this.checkAllField()) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    saveGlobalSearch() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("title_id", this.item.title_id);
          formData.append("title_en", this.item.title_en);
          formData.append("meta_desc_id", this.item.meta_desc_id);
          formData.append("meta_desc_en", this.item.meta_desc_en);
          formData.append("content_id", this.item.content_id);
          formData.append("content_en", this.item.content_en);
          formData.append("url_id", this.item.url_id);
          formData.append("url_en", this.item.url_en);
          formData.append("type_name", this.item.type_name);
          formData.append("sync_type", "manual");
          this.$store
            .dispatch("GlobalSearchModule/postGlobalSearch", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "GlobalSearch" });
              this.$swal({
                type: "success",
                title: "Your data has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.data.join(","),
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    checkAllField() {
      return this.item.title_id != "" && this.item.title_en != "" && 
              this.item.meta_desc_id != "" && this.item.meta_desc_en != "" && 
              this.item.content_id != "" && this.item.content_en != "" && 
              this.item.url_id != "" && this.item.url_en != "";
    }
  }
};
</script>
